import { Vector2 } from "./Vector2";

export class Entity extends EventTarget {
  group: string | null = null;
  position = new Vector2();
  radius = 0.5;
  angle = 0;
  color = "#fff4";
  text = "#";
  angle_velocity = 0;
  velocity = new Vector2();
  forces = <Record<string, Vector2>>{};

  clone() {
    return Object.assign(new Entity(), this, {
      position: Vector2.from(this.position),
      velocity: Vector2.from(this.velocity),
      forces: {},
    });
  }
}
